export default import.meta.ROLLUP_FILE_URL_6RARxp2Lk_MebqaFz_U6Bg